<template>
  <modal 
    name="winner-requirements-modal"
    @closed="$emit('updateComparisonData')"
    @before-open="handleBeforeOpen"
    style="z-index: 1001;"
  >
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Վավերապայմանների մուտքագրում</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('winner-requirements-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <label for="bank">Բանկ / Գանձապետարան</label>
              <input 
                v-model="$v.winner.bank.$model"
                name="bank"
                type="text"
                class="form-control"
              >
            </div>
          </div>
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <label for="account-number">Հաշվեհամար</label>
              <the-mask 
                v-model.number="$v.winner.account_number.$model"
                mask="################"
                type="text"
                name="account-number"
                class="form-control"
                :class="{'border-danger': $v.winner.account_number.$dirty && !$v.winner.account_number.required}"
                id="account-number"
              />
            </div>
          </div>
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <label for="director">Տնօրենի անուն ազգանուն</label>
              <input 
                v-model="$v.winner.director.$model"
                name="director"
                type="text"
                class="form-control"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button :disabled="isLoading" @click="save" class="btn btn-sm btn-light mr-3">
        <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Պահպանել
      </button>
    </div>
  </modal>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import 'vue-date-pick/dist/vueDatePick.css';

  export default {
    name: 'WinnerRequirementsModal',
    components: {  },
    data() {
      return {
        isLoading: false,
        participantGroup: {},
        winner: {
          bank: '',
          account_number: '',
          director: '',
        },
      }
    },
    validations() {
      const rules = {
        winner: {
          bank: {required},
          account_number: {required},
          director: {required},
        },
      }
      return rules
    },
    computed: { },
    methods: {
      handleBeforeOpen({params}) {
        console.log(params)
        if(params.user_datas){
          this.winner.bank = params.user_datas.bank;
          this.winner.account_number = params.user_datas.account_number;
          this.winner.director = params.user_datas.director;
        }
        this.participantGroup = params
        if(this.participantGroup.participant_user){
          this.winner.bank = this.participantGroup.participant_user.organisation.bank_name.hy;
          this.winner.account_number = this.participantGroup.participant_user.organisation.bank_account;
          this.winner.director = this.participantGroup.participant_user.organisation.director_name.hy;
        }
        if(this.participantGroup.director || this.participantGroup.bank || this.participantGroup.bank_account){
          this.winner.bank = this.participantGroup.bank;
          this.winner.account_number = this.participantGroup.bank_account;
          this.winner.director = this.participantGroup.director;
        }
      },
      save() {
        if(!this.$v.winner.$invalid) {
          this.isLoading = true;
          this.$client.post(`participant-group/addPersonalInfo/${this.participantGroup.id}`, this.winner).then((response) => {
            if(response.data.status){
              this.$notify({
                group: 'foo',
                type: 'success',
                text: 'Հաջողությամբ պահպանված է'
              })
            }
            this.isLoading = false
            this.$modal.hide('winner-requirements-modal')
          }).catch(e => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Ինչ որ բան այն չէ',
              text: 'Կրկին փորձեք!'
            })
            this.isLoading = false
          })
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը պահպանելու համար!'
          })
        }
      }
    },
  }
</script>

<style scoped>
 .date-picker {
    display: block;
    width: 100%;
    border: 1px solid #e8ebf3;
    border-radius: .25rem;
    border-bottom: 1px solid #e8ebf3;
  }
  /deep/ .vdpWithInput > input {
    width: 100%;
    height: calc(1.8em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .845rem;
    font-weight: 400;
    line-height: 1.8;
    color: #303e67;
    border: none;
  }
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    width: 500px !important;
    position: absolute;
    right: 0 !important;;
    left: 0 !important;;
    margin: auto;
    height: 80% !important;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>